/* ============================================================
   NICHOLASGHN — global.js
   Utility condivise (es. sync conteggio carrello al load).
   ============================================================ */
(function(){
  // Sync cart count on every page load (in caso il tema cache mostri valore stale)
  if(document.querySelector('[data-cart-count]')){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          el.textContent = cart.item_count;
          el.classList.toggle('show', cart.item_count > 0);
        });
      })
      .catch(function(){});
  }
})();
